import { parseInboundPayload } from '../inbound';
import { createArrayWithBracesParser, numberParser, stringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
export const SET_DISCARD_PHASE_DONE_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'currNumHoleCards', parser: numberParser },
        { name: 'updatedAllInPlayerHands', parser: createArrayWithBracesParser(updatedAllInPlayerHandParser) },
        { name: 'betRound', parser: numberParser }
    ]
};
function updatedAllInPlayerHandParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, updatedAllInPlayerHandPartDefinitions);
}
const updatedAllInPlayerHandPartDefinitions = [
    { name: 'playerId', parser: numberParser },
    { name: 'cardShorthands', parser: createArrayWithBracesParser(stringParser) }
];
